import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShopComponent } from './shop/shop.component';
import { PagesComponent } from './pages/pages.component';
import { ElementsComponent } from './elements/elements.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'nuestra-historia',
    loadChildren: () => import('./nuestra-historia/nuestra-historia.module').then(m => m.NuestraHistoriaModule)
  },
  {
    path: 'nuestra-finca',
    loadChildren: () => import('./nuestra-finca/nuestra-finca.module').then(m => m.NuestraFincaModule)
  },
  {
    path: 'procesos',
    loadChildren: () => import('./procesos/procesos.module').then(m => m.ProcesosModule)
  },
  {
    path: 'aove',
    loadChildren: () => import('./aove/aove.module').then(m => m.AoveModule)
  },
  {
    path: 'galeria',
    loadChildren: () => import('./galeria/galeria.module').then(m => m.GaleriaModule)
  },
  {
    path: 'oliart',
    loadChildren: () => import('./oliart/oliart.module').then(m => m.OliartModule)
  },
  {
    path: 'fincarocamella',
    loadChildren: () => import('./fincarocamella/fincarocamella.module').then(m => m.FincarocamellaModule)
  },
  {
    path: 'contacto',
    loadChildren: () => import('./contacto/contacto.module').then(m => m.ContactoModule)
  },
  {
    path: 'shop',
    component: ShopComponent,
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
  },
  { 
    path: 'pages',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },
  { 
    path: 'elements', 
    component: ElementsComponent,
    loadChildren: () => import('./elements/elements.module').then(m => m.ElementsModule) },
  {
    path: '**', // Navigate to Home Page if not found any page
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {    
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'disabled'  ,
     onSameUrlNavigation: 'reload'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
